import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { environment } from 'environments/environment';
import { FileFormsService, fileInputParams, HttpService, MessageService, fileFormsParams, FunctionsService, CombosConfiguration } from 'brainloper-ui';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { Router } from '@angular/router';
import { Company } from 'app/models2/administration/company';
import { Country } from 'app/models2/administration/country';
import { Plan } from 'app/models2/configuration/plan';
import { Region } from 'app/models2/administration/region';
import { City } from 'app/models2/administration/city';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { BaseResponse } from 'app/models2/commos/base-response';
import { UpdateData } from 'app/models2/commos/update-data';



@Component({
  selector: 'app-form-company',
  templateUrl: './form-company.component.html',
  styleUrls: ['./form-company.component.scss']
})
export class FormCompanyComponent implements OnInit {

  private urlGetPaises: string = `${EndpointDictionary.Contry.COUNTRY_COMBO}`
  private urlGetRegion: string = `${EndpointDictionary.Region.REGION_COMBO}`
  private urlGetCity: string = `${EndpointDictionary.City.CITY_COMBO}`
  private urlGetModules: string = `${EndpointDictionary.Module.MODULE_COMBO}`
  private urlPostCompanias:string = `${EndpointDictionary.Company.CRUD_COMPANY_DATA}`
  public FormTitle: String = ""
  public onSubmitBotonText: String = ""
  public compania: Company

  private resSubmit: Company
  private addCompania: Company
  private modules: any

  public comboPaises: Array<Country>
  public comboPlans: Array<Plan>
  public comboDepartamentos: Array<Region>
  public comboCiudades: Array<City>
  public selOpEstado: String = "";
  public movil = screen.width > 600 ? false : true

  private file = null
  private fileOld: fileFormsParams[] =[{
    id:'old',
    value:''
  }]

  public fileInput: fileInputParams = {
    typeFile: "imagen",
    input: "formulario",
    label: "Logo de la compañia",
    edit: true,
    style: {
      width: '100%'
    }
  }

  public companiaForm = new UntypedFormGroup({
    name: new UntypedFormControl(''),
    nit: new UntypedFormControl(''),
    state: new UntypedFormControl(''),
    description: new UntypedFormControl(''),
    address: new UntypedFormControl(''),
    logo: new UntypedFormControl(''),
    countryId: new UntypedFormControl(''),
    regionId: new UntypedFormControl(''),
    cityId: new UntypedFormControl(''),
    manager: new UntypedFormControl(''),
    phone: new UntypedFormControl(''),
    mobile: new UntypedFormControl(''),
    email: new UntypedFormControl(''),
    lastPaymentDate:new UntypedFormControl(''),
    planId:new UntypedFormControl(5),
    paymentPeriod:new UntypedFormControl(1),
    itemCount: new UntypedFormControl(0)
  });

  public reloadComboCountry = new EventEmitter<any>()
  public combosConfigCountry: CombosConfiguration = {
    visibleField: 'country',
    selectionField: 'id',
    urlCombo: this.urlGetPaises,
    label: 'Pais',
  }

  public reloadComboRegion = new EventEmitter<any>()
  public combosConfigRegion: CombosConfiguration = {
    visibleField: 'region',
    selectionField: 'id' ,
    label: 'Departamento',
  }

  public reloadComboCity = new EventEmitter<any>()
  public combosConfigCity: CombosConfiguration = {
    visibleField: 'city',
    selectionField: 'id' ,
    label: 'ciudad',
  }

  public reloadComboModule = new EventEmitter<any>()
  public combosConfigModule: CombosConfiguration = {
    visibleField: 'name',
    urlCombo: this.urlGetModules,
    selectionField: 'id' ,
    label: 'Modulos'
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    private http: HttpService, //Servicio HTTP de Eter
    private message: MessageService, //Servicio de mensaje emergente Eter
    private formFile: FileFormsService,
    private functionsEter: FunctionsService,
    private router: Router,
  ) { }

  async ngOnInit() {
    this.compania = this.data
    console.log(this.data)
    this.loadPlan()
    this.LoadCountries()
    if(this.compania.state == undefined){
      this.FormTitle = "Nueva compañia"
      this.onSubmitBotonText = "Crear"
    } else{
      this.FormTitle = "Editar compañia"
      this.onSubmitBotonText = "Actualizar"
      this.combosConfigCountry.selected = this.compania.countryId
      this.selOpEstado = this.compania.state.toString()
      this.changesCountry(this.compania.countryId)
      this.changesRegion(this.compania.regionId)
      this.combosConfigModule.selected = this.compania.modules
      this.reloadComboModule.emit("selected")
      for (let controls of Object.keys(this.companiaForm.controls)) {
        if(this.compania[controls]){
          this.companiaForm.controls[controls].setValue(this.compania[controls].toString())
        }
      }
    }
  }



  async onSubmit(_data: Company) {
    let _addCompania : Company
    this.message.openLoading('Cargando...', 'Agregando compañias.')
    try {
      _addCompania = _data
      _addCompania.lastPaymentDate = this.functionsEter.dateForm(_data.lastPaymentDate)
      _addCompania.modules = this.modules
      if (this.file == null) {
        console.log('No se agrego imagen')
      } else {
        let formImg = this.formFile.createMultipartForm(this.file)
        let res: string = await this.http.postDataBody(`${EndpointDictionary.Docs.DOCS_SUBIR}?companyId=0`, formImg)
        _data.logo = res
      }
      console.log("data", this.data)
      if(this.data >= 0){
        let resSubmit: GenericResponse = await this.http.postDataBody(this.urlPostCompanias, _addCompania)
        console.log("ressumb", resSubmit)
        if(resSubmit){
          this.message.SuccessToast('Compañia agregada correctamente.')
          this.message.closeLoading()
        } else{
          this.message.ErrorToast('Error agregando compañia.')
          this.message.closeLoading()
        }
      } else{
        _addCompania.id = this.compania.id

        let resSubmit: GenericResponse = await this.http.putDataBody(this.urlPostCompanias, _addCompania)
        if(resSubmit){
          this.message.SuccessToast('Compañia actualizada correctamente.')
          this.message.closeLoading()
        } else{
          this.message.ErrorToast('Error actualizando compañia.')
          this.message.closeLoading()
        }
        this.message.closeLoading()

      }
    } catch (error) {
      this.message.ErrorToast('Error en compañia.')
      this.message.closeLoading()

    }
  }

  async LoadCountries(){
    let urlGetPaises:string = `${EndpointDictionary.Contry.COUNTRY_COMBO}`
    let resPais: BaseResponse<Array<Country>> = await this.http.getData(urlGetPaises).toPromise()
    if(resPais.code === 0){
      this.comboPaises = resPais.body
    } else{
      //console.log('Error cargando paises.')
    }
  }

  async loadPlan(){
    let urlGetPlans:string = `${EndpointDictionary.Plans.PLANS_COMBO}`
    let resPlan: Array<Plan> = await this.http.getDataBody(urlGetPlans)
    if(resPlan){
      this.comboPlans = resPlan
    } else{
      console.log('Error cargando Planes.')
    }
  }

  changesCountry($event: number) {
    if ($event && $event > 0) {
      this.companiaForm.controls.countryId.setValue($event)
      this.combosConfigRegion.urlCombo = `${this.urlGetRegion}/${$event}`
      this.reloadComboRegion.emit()
      if (this.compania.state != undefined) {
       this.combosConfigRegion.selected = this.compania.regionId
      }
    }

  }
  changesRegion($event: number){
    if ($event && $event > 0) {
      this.companiaForm.controls.regionId.setValue($event)
      this.combosConfigCity.urlCombo = `${this.urlGetCity}/${$event}`
      this.reloadComboCity.emit()
      if (this.compania.state != undefined) {
        this.combosConfigCity.selected = this.compania.cityId
    }
  }
  }

  ValueIDModule($event: number[]){
   this.modules = $event
  }

  fileSave($event: UpdateData<File>) {
    if($event.compressor){
      this.file = $event.compressor
    }else{
      this.file = $event.new
    }
  }

}
